.card {
  align-items: center;
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 16px;
  box-shadow: var(--pgm-sys-elevation-level1);
  box-sizing: border-box;
  color: var(--pgm-sys-color-on-surface);
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6);
  position: relative;
  text-decoration: none;
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1);
}

.card::before {
  background-color: var(--pgm-sys-color-on-surface-variant);
  border-radius: inherit;
  content: "";
  inset: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 150ms cubic-bezier(0.2, 0, 0, 1);
}

.card:hover::before {
  opacity: 0.08;
}

.card:active::before {
  opacity: 0.1;
}

.card:hover,
.card:focus,
.card:active {
  color: var(--pgm-sys-color-on-surface);
  text-decoration: none;
}

.card:hover {
  box-shadow: var(--pgm-sys-elevation-level2);
}

.card:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: 3px;
}

.icon {
  color: var(--pgm-sys-color-secondary);
  flex-shrink: 0;
  font-size: 44px;
  font-variation-settings:
    "FILL" 1,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
  line-height: 44px;
}

.infos {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.title,
.description {
  color: var(--pgm-sys-color-on-surface);
}

.trailing {
  color: var(--pgm-sys-color-on-surface-variant);
  flex-shrink: 0;
  font-size: 24px;
  line-height: 24px;
}

@media (max-width: 599.98px) {
  .card {
    align-items: flex-start;
    gap: var(--pgm-sys-spacing-4);
    padding: var(--pgm-sys-spacing-4);
  }

  .trailing {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .card,
  .card::before {
    transition: none;
  }
}
